/**
 * Push Test Page
 * Push notification testing interface
 * Matches the old admin page layout with two-column grid and tabs
 */

import { useState } from 'react';
import {
  SendNotificationForm,
  DeviceTokens,
  NotificationLogs,
  PushStats,
} from '@/features/push-notifications';
import { useI18n } from '@/i18n';

type TabType = 'tokens' | 'logs';

export function PushTestPage() {
  const { messages } = useI18n();
  const t = messages.pushNotifications;
  const [activeTab, setActiveTab] = useState<TabType>('tokens');

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Page Header */}
      <h1 className="text-2xl font-bold text-gray-900 mb-6">{t.pageTitle}</h1>

      {/* Statistics Section */}
      <div className="mb-6">
        <PushStats />
      </div>

      {/* Main Grid - Two Columns */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left Column: Send Notification Form */}
        <div>
          <SendNotificationForm />
        </div>

        {/* Right Column: Tabs (Tokens & Logs) */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          {/* Tab Headers */}
          <div className="border-b border-gray-200">
            <nav className="flex">
              <button
                onClick={() => setActiveTab('tokens')}
                className={`px-6 py-3 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === 'tokens'
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="mr-2">📱</span>
                {t.tokens.tabTitle}
              </button>
              <button
                onClick={() => setActiveTab('logs')}
                className={`px-6 py-3 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === 'logs'
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="mr-2">📋</span>
                {t.logs.tabTitle}
              </button>
            </nav>
          </div>

          {/* Tab Content */}
          {activeTab === 'tokens' && <DeviceTokens />}
          {activeTab === 'logs' && <NotificationLogs />}
        </div>
      </div>
    </div>
  );
}
